import { render, staticRenderFns } from "./EmployeeDocumentsListComponent.vue?vue&type=template&id=5bd1f4dc&"
import script from "./EmployeeDocumentsListComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocumentsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports